import axios from 'axios';
import useAuthStore from '@/store/modules/auth.js'; // Adjust the import path as needed
import usePhoneShortcutStore from '@/store/modules/phoneShortcut.js'; // Adjust the import path as needed

/**
 * Send phone shortcut installation status to API
 * @param {Object} payload - Contains shortcutCreated boolean
 * @param {boolean} payload.shortcutCreated - Whether the shortcut was created
 * @returns {Promise} API response
 */
export const phoneShortcutInstalled = async (payload) => {
  console.log("Invoking phoneShortcutInstalled");

  // Get the JWT token from the auth store
  const authStore = useAuthStore();
  const token = authStore.jwtToken;
  console.log(authStore.jwtToken);

  try {
    const response = await axios({
      url: 'api/phoneShortcutInstalled',
      method: 'POST',
      headers: {
        Authorization: token,
      },
      data: {
        shortcutCreated: payload.shortcutCreated,
      },
    });

    // Update the store with the response data
    const phoneShortcutStore = usePhoneShortcutStore();
    phoneShortcutStore.storeHomeScreenModalDisable(response.data);

    return response;
  } catch (error) {
    console.log(`Invoking phoneShortcutInstalled failed with the following error: ${error}`);
    throw error;
  }
};
